// Module
var code = `<md-icon md-svg-icon="bambora-partner-logo" class="bambora-partner-icon partner-icon-unauthenticated" alt="Bambora Reseller"></md-icon>`;
// Exports
module.exports = code;